import api from './api';

// Supplies Service
export const suppliesService = {
    list: (params = {}) => {
        return api.get('/supplies', { params });
    },
    get: (id) => {
        return api.get(`/supplies/${id}`);
    },
    create: (data) => {
        return api.post('/supplies', data);
    },
    update: (id, data) => {
        return api.put(`/supplies/${id}`, data);
    },
    delete: (id) => {
        return api.delete(`/supplies/${id}`);
    },
    getCostHistory: (id, params = {}) => {
        return api.get(`/supplies/${id}/cost-history`, { params });
    },
    updateCost: (id, data) => {
        return api.post(`/supplies/${id}/cost-history`, data);
    },
    patchCostHistory: (supplyId, historyId, data) => {
        return api.patch(`/supplies/${supplyId}/cost-history/${historyId}`, data);
    },
    deleteCostHistory: (supplyId, historyId) => {
        return api.delete(`/supplies/${supplyId}/cost-history/${historyId}`);
    },
    getStockMovements: (id, params = {}) => {
        return api.get(`/supplies/${id}/stock-movements`, { params });
    },
    adjustInventory: (id, data) => {
        return api.post(`/supplies/${id}/stock-adjustment`, data);
    },
};

// Resources Service
export const resourcesService = {
    list: (params = {}) => {
        return api.get('/resources', { params });
    },
    get: (id) => {
        return api.get(`/resources/${id}`);
    },
    create: (data) => {
        return api.post('/resources', data);
    },
    update: (id, data) => {
        return api.put(`/resources/${id}`, data);
    },
    delete: (id) => {
        return api.delete(`/resources/${id}`);
    },
    getCostHistory: (id, params = {}) => {
        return api.get(`/resources/${id}/cost-history`, { params });
    },
    createCostHistory: (id, data) => {
        return api.post(`/resources/${id}/cost-history`, data);
    },
    patchCostHistory: (resourceId, historyId, data) => {
        return api.patch(`/resources/${resourceId}/cost-history/${historyId}`, data);
    },
    deleteCostHistory: (resourceId, historyId) => {
        return api.delete(`/resources/${resourceId}/cost-history/${historyId}`);
    },
};

// Product lines (auxiliary)
export const productLinesService = {
    list: (params = {}) => {
        return api.get('/product-lines', { params });
    },
    get: (id) => {
        return api.get(`/product-lines/${id}`);
    },
    create: (data) => {
        return api.post('/product-lines', data);
    },
    update: (id, data) => {
        return api.put(`/product-lines/${id}`, data);
    },
    delete: (id) => {
        return api.delete(`/product-lines/${id}`);
    },
};

// Products Service
export const productsService = {
    list: (params = {}) => {
        return api.get('/products', { params });
    },
    get: (id) => {
        return api.get(`/products/${id}`);
    },
    create: (data) => {
        return api.post('/products', data);
    },
    update: (id, data) => {
        return api.put(`/products/${id}`, data);
    },
    delete: (id) => {
        return api.delete(`/products/${id}`);
    },
    getStockMovements: (id, params = {}) => {
        return api.get(`/products/${id}/stock-movements`, { params });
    },
    adjustInventory: (id, data) => {
        return api.post(`/products/${id}/stock-adjustment`, data);
    },
};

export const movementTypesService = {
    list: (params = {}) => api.get('/movement-types', { params }),
    get: (id) => api.get(`/movement-types/${id}`),
    create: (data) => api.post('/movement-types', data),
    update: (id, data) => api.put(`/movement-types/${id}`, data),
    delete: (id) => api.delete(`/movement-types/${id}`),
};

// Production Orders Service
export const productionOrdersService = {
    list: (params = {}) => {
        return api.get('/production-orders', { params });
    },
    stats: () => {
        return api.get('/production-orders/stats');
    },
    get: (id) => {
        return api.get(`/production-orders/${id}`);
    },
    create: (data) => {
        return api.post('/production-orders', data);
    },
    update: (id, data) => {
        return api.put(`/production-orders/${id}`, data);
    },
    updateBom: (id, data) => {
        return api.patch(`/production-orders/${id}/bom`, data);
    },
    cancel: (id) => {
        return api.post(`/production-orders/${id}/cancel`);
    },
    finish: (id) => {
        return api.post(`/production-orders/${id}/finish`);
    },
    report: (id, data) => {
        return api.post(`/production-orders/${id}/report`, data);
    },
    getReports: (id) => {
        return api.get(`/production-orders/${id}/reports`);
    },
};

// Warehouses Service
export const warehousesService = {
    list: (params = {}) => {
        return api.get('/warehouses', { params });
    },
    get: (id) => {
        return api.get(`/warehouses/${id}`);
    },
    create: (data) => {
        return api.post('/warehouses', data);
    },
    update: (id, data) => {
        return api.put(`/warehouses/${id}`, data);
    },
    delete: (id) => {
        return api.delete(`/warehouses/${id}`);
    },
};

